var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { staticClass: "OpTableContentFilter" },
    [
      _vm.options.currHeaeItem.fieldType === "1"
        ? _c("span", [_vm._v(_vm._s(_vm.type1))])
        : _vm._e(),
      _vm._v(" "),
      _vm.options.currHeaeItem.fieldType === "2"
        ? _c(
            "span",
            _vm._l(_vm.type2, function (item, index) {
              return _c("p", { key: index }, [
                _vm.options.currRow[item.fieldCode]
                  ? _c("span", [
                      _vm._v(
                        _vm._s(item.fieldName) +
                          _vm._s(_vm.options.currRow[item.fieldCode])
                      ),
                    ])
                  : _vm._e(),
              ])
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.options.currHeaeItem.fieldType === "3"
        ? _c(
            "span",
            _vm._l(_vm.type3, function (item, index) {
              return _c(
                "span",
                { key: index },
                [
                  item.fieldType === "3-1" &&
                  _vm.options.currRow[item.fieldCode]
                    ? _c(
                        "p",
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "link-txt",
                              attrs: {
                                to: {
                                  path: item.jumpUrl,
                                  query: { id: _vm.options.currRow.id },
                                },
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.options.currRow[item.fieldCode])
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  item.fieldType === "3-2" &&
                  _vm.options.currRow[item.fieldCode]
                    ? _c("el-tag", { attrs: { size: "mini" } }, [
                        _vm._v(_vm._s(_vm.options.currRow[item.fieldCode])),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  item.fieldType === "3-3" &&
                  _vm.options.currRow[item.fieldCode]
                    ? _c("span", [
                        _vm._v(_vm._s(_vm.options.currRow[item.fieldCode])),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  item.fieldType === "3-4" ? _c("span") : _vm._e(),
                  _vm._v(" "),
                  item.fieldType === "3-8" &&
                  _vm.options.currRow[item.fieldCode] &&
                  _vm.options.currRow[item.fieldCode].length > 0
                    ? _c(
                        "span",
                        _vm._l(
                          _vm.options.currRow[item.fieldCode],
                          function (val, valIndex) {
                            return _c("p", { key: valIndex }, [
                              _vm._v(_vm._s(val)),
                            ])
                          }
                        ),
                        0
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  item.fieldType === "3-6"
                    ? _c(
                        "span",
                        { staticClass: "relatedPersonnel" },
                        [
                          _c("PersonalInfo", {
                            attrs: {
                              "curr-val": _vm.options.currRow[item.fieldCode],
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  item.fieldType === "3-7" &&
                  _vm.options.currRow[item.fieldCode] &&
                  _vm.options.currRow[item.fieldCode].length > 0
                    ? _c(
                        "span",
                        _vm._l(
                          _vm.options.currRow[item.fieldCode],
                          function (colorItem, colorIndex) {
                            return _c(
                              "span",
                              {
                                key: colorIndex,
                                staticStyle: {
                                  "margin-right": "5px",
                                  "text-decoration": "underline",
                                  cursor: "pointer",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.getImgList(colorItem.colorId)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(colorItem.colorName))]
                            )
                          }
                        ),
                        0
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  item.fieldType === "3-9"
                    ? _c("span", [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              "margin-right": "5px",
                              "text-decoration": "underline",
                              cursor: "pointer",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.getSimilarModels(
                                  _vm.options.currRow[item.fieldCode]
                                )
                              },
                            },
                          },
                          [_vm._v(_vm._s(item.fieldName))]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  item.fieldType === "3-10"
                    ? _c("span", [
                        _c(
                          "p",
                          [
                            _c(
                              "el-popover",
                              {
                                attrs: {
                                  placement: "bottom",
                                  width: "400",
                                  trigger: "click",
                                },
                                on: {
                                  show: function ($event) {
                                    return _vm.getProcessPlateList(
                                      _vm.options.currRow["id"]
                                    )
                                  },
                                },
                              },
                              [
                                _c(
                                  "el-table",
                                  {
                                    attrs: {
                                      size: "mini",
                                      data: _vm.processPlateList,
                                    },
                                  },
                                  [
                                    _c("el-table-column", {
                                      attrs: {
                                        property: "overprintPicture",
                                        label: "主图片",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                _c("img", {
                                                  attrs: {
                                                    width: "100",
                                                    src:
                                                      _vm.imgPrefix +
                                                      scope.row
                                                        .overprintPicture,
                                                  },
                                                }),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        property: "overprintDesignNo",
                                        label: "套版SPU编码",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                _vm._v(
                                                  _vm._s(
                                                    scope.row.overprintDesignNo
                                                  )
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        property: "salesVolumesAndCostPrice",
                                        label: "销售数量成本价",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                _c("p", [
                                                  _vm._v(
                                                    _vm._s(
                                                      scope.row.salesVolumes
                                                    )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("p", [
                                                  _vm._v(
                                                    _vm._s(scope.row.costPrice)
                                                  ),
                                                ]),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        property: "plateStatusAndOrderStatus",
                                        label: "打版状态下单状态",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                _c("p", [
                                                  _vm._v(
                                                    _vm._s(
                                                      scope.row.plateStatus
                                                    )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("p", [
                                                  _vm._v(
                                                    _vm._s(
                                                      scope.row.orderStatus
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        property: "overprintDesignerName",
                                        label: "选款人设计师",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                _c("p", [
                                                  _vm._v(
                                                    _vm._s(
                                                      scope.row.overprintPayer
                                                    )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("p", [
                                                  _vm._v(
                                                    _vm._s(
                                                      scope.row
                                                        .overprintDesignerName
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      "margin-right": "5px",
                                      "text-decoration": "underline",
                                      cursor: "pointer",
                                    },
                                    attrs: { slot: "reference" },
                                    slot: "reference",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.options.currRow["overprintDesignNo"]
                                      )
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  item.fieldType === "3-11"
                    ? _c(
                        "span",
                        { staticClass: "supplierContacts" },
                        [
                          _c("ContactInfo", {
                            attrs: {
                              "curr-val": _vm.options.currRow[item.fieldCode],
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  item.fieldType === "3-12"
                    ? _c(
                        "span",
                        { staticClass: "supplierContacts" },
                        [
                          _c(
                            "el-popover",
                            {
                              attrs: { placement: "bottom", trigger: "hover" },
                            },
                            [
                              _c("div", { staticClass: "related-content" }, [
                                _c("p", [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.options.currRow[item.fieldCode]
                                      )
                                    ),
                                  ]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    color: "#FF8850",
                                    "text-decoration": "underline",
                                    cursor: "pointer",
                                  },
                                  attrs: { slot: "reference" },
                                  slot: "reference",
                                },
                                [_vm._v("备注")]
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  item.fieldType === "3-13"
                    ? _c("span", [
                        _c("p", { staticStyle: { padding: "10px" } }),
                      ])
                    : _vm._e(),
                ],
                1
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.options.currHeaeItem.fieldType === "4" && _vm.type4
        ? _c(
            "span",
            [
              _c(
                "el-popover",
                {
                  attrs: { placement: "left", width: "600", trigger: "hover" },
                },
                [
                  _c("img", {
                    attrs: { width: "600", src: _vm.imgPrefix + _vm.type4 },
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    { attrs: { slot: "reference" }, slot: "reference" },
                    [
                      _c("img", {
                        attrs: {
                          width: "40",
                          height: "40",
                          src: _vm.imgPrefix + _vm.type4,
                        },
                      }),
                    ]
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            "modal-append-to-body": false,
            center: "",
            title: "图片详情",
            visible: _vm.showImgVisible,
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showImgVisible = $event
            },
          },
        },
        [
          _vm.imgList && _vm.imgList.length < 1
            ? _c(
                "span",
                { staticStyle: { display: "block", "text-align": "center" } },
                [_vm._v("暂无图片")]
              )
            : _c(
                "el-carousel",
                { attrs: { height: "300px" } },
                _vm._l(_vm.imgList, function (imgItem, imgImdex) {
                  return _c("el-carousel-item", { key: imgImdex }, [
                    _c("img", {
                      attrs: { src: _vm.imgPrefix + imgItem.url, alt: "" },
                    }),
                  ])
                }),
                1
              ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }